<template>
    <rich-text-page field="privacyPolicy" title="Privacy Policy">
        <template #description>Shown at lavishlocations.com/privacypolicy.</template>
    </rich-text-page>
</template>

<script>
    import RichTextPage from "../components/rich-text-page";

    export default {
        name: "PrivacyPolicy",
        components: {RichTextPage},
    }
</script>



// WEBPACK FOOTER //
// src/site-content/PrivacyPolicy.vue